"use strict";
import { getNativeAddress } from "constants/uniswapAddresses";
import { buildCurrencyId, currencyIdToGraphQLAddress } from "utils/uniswapCurrencyId";
export const BACKEND_NATIVE_CHAIN_ADDRESS_STRING = "NATIVE";
export function tokenAddressOrNativeAddress(address, chainId) {
  const nativeAddress = getNativeAddress(chainId);
  if (address !== BACKEND_NATIVE_CHAIN_ADDRESS_STRING && address !== nativeAddress) {
    return address;
  }
  return currencyIdToGraphQLAddress(buildCurrencyId(chainId, nativeAddress));
}
